/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Font_SizeInputs */

const en_font_size = /** @type {(inputs: Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Font Size`)
};

const es_font_size = /** @type {(inputs: Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño de fuente`)
};

const fr_font_size = /** @type {(inputs: Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille de la police`)
};

const de_font_size = /** @type {(inputs: Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftgröße`)
};

const ja_font_size = /** @type {(inputs: Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォントサイズ`)
};

const zh_font_size = /** @type {(inputs: Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字体大小`)
};

const ar_font_size = /** @type {(inputs: Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حجم الخط`)
};

const id_font_size = /** @type {(inputs: Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukuran Fon`)
};

const it_font_size = /** @type {(inputs: Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione Carattere`)
};

const ru_font_size = /** @type {(inputs: Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер шрифта`)
};

const pt_font_size = /** @type {(inputs: Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho da Fonte`)
};

const ko_font_size = /** @type {(inputs: Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`글꼴 크기`)
};

/**
* | output |
* | --- |
* | "Font Size" |
*
* @param {Font_SizeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const font_size = /** @type {((inputs?: Font_SizeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Font_SizeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_font_size(inputs)
	if (locale === "es") return es_font_size(inputs)
	if (locale === "fr") return fr_font_size(inputs)
	if (locale === "de") return de_font_size(inputs)
	if (locale === "ja") return ja_font_size(inputs)
	if (locale === "zh") return zh_font_size(inputs)
	if (locale === "ar") return ar_font_size(inputs)
	if (locale === "id") return id_font_size(inputs)
	if (locale === "it") return it_font_size(inputs)
	if (locale === "ru") return ru_font_size(inputs)
	if (locale === "pt") return pt_font_size(inputs)
	return ko_font_size(inputs)
});